import { instance } from './index';

export const getChargeBoardPerYear = async (year: number, storeId: number) => {
  const response = await instance.get(`/user/store/deposit/${year}/${storeId}`);
  return response.data;
};
